import { gql } from '@apollo/client';
import DirectMessageFragment from "../../fragments/DirectMessage";

const GET_CONVERSATION = gql`
  query getConversation($directMessageConversationId: Int!, $last: Int) {
    directMessages {
      conversation(directMessageConversation: $directMessageConversationId) {
        directMessageConversationId
        latestMessageId
        latestReadMessageId
        latestReadMessageTime
        isApproved
        hasCurrentUserApproved
        members {
          name
          userId
          username
          avatarUrl
        }
        messages(last: $last) {
          #edges
          items {
            ...DirectMessageFragment
          }
          #pageInfo
          #totalCount
        }
        unreadMessageCount
      }
    }
  }
  ${DirectMessageFragment}
`;

export default GET_CONVERSATION;
